module.exports = __webpack_public_path__ + "static/img/92070B_1_R_20200807_LC.4207ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92070B_1_R_20200807_LC.png
// module id = Rq+Z
// module chunks = 0